
/**
 * @file 使模块可配置化
 * @author dafo<huanghouin@baijiahulian.com>
 * @module util/configurable
 */
import {
    extend,
    camelToUnder
} from './json';

/**
 * 使函数支持配置化
 *
 * @function configurable
 * @param {Function} fn 需要可配置化的函数
 * @param {?Object=} [defaults={}] 默认配置值
 * @return {Function} 包装后支持可配置化的函数
 */
export default (fn, defaults = {}) => {
    const config = {...defaults};

    const mod = (json, ...args) => fn(extend({}, config, camelToUnder(json)), ...args);
    mod.setConfig = (defaults = {}) => extend(config, camelToUnder(defaults));

    return mod;
};
